module.exports = __webpack_public_path__ + "static/media/ponto-interrogacao-cinza.520c531f.svg";